function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m29.549 60.838 33.584-49.194a4.9944 4.9944 0 0 0-1.3099-6.9377l-4.1216-2.8161a4.9929 4.9929 0 0 0-6.9377 1.3099l-27.778 40.688-12.192-8.6996a4.9914 4.9914 0 0 0-6.963 1.1642l-2.9024 4.0636a4.9929 4.9929 0 0 0 1.1642 6.963l20.578 14.683a4.8695 4.8695 0 0 0 6.8782-1.2237z",
    fill: "currentColor",
    style: {
      strokeWidth: 1.4869
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.601aad2f.svg";
export { ForwardRef as ReactComponent };